module.exports = __webpack_public_path__ + "img/UT0397.be0b61f0.png";